export default {
  refreshYourResults: 'Opdater dine resultater',
  weNeedTo: 'For de seneste priser og tilgængelighed, har vi brug for at',
  refreshResults: 'opdatere dine resultater.',
  okRefresh: 'Ok, opdater',
}
